"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _sprintfJs = require("sprintf-js");

var _humanTime = require("../humanTime");

var _momentPropType = _interopRequireDefault(require("../_utils/momentPropType"));

var Duration =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Duration, _PureComponent);

  function Duration() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Duration);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Duration)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "tick", function () {
      _this.forceUpdate();

      _this.setUpdateTimeout();
    });
    return _this;
  }

  (0, _createClass2.default)(Duration, [{
    key: "run",
    value: function run() {
      if (!this.tId) {
        this.setUpdateTimeout();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.tId) {
        clearTimeout(this.tId);
        this.tId = null;
      }
    }
  }, {
    key: "setUpdateTimeout",
    value: function setUpdateTimeout() {
      var diff = (Date.now() - this.props.from) / 1000;
      this.stop();

      if (this.props.to) {
        return;
      }

      var timeout = diff >= 60 ? Math.ceil(diff / 60) * 60 - diff // update on next minute
      : .25; // update 4 times per second

      this.tId = setTimeout(this.tick, timeout * 1000);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.to) {
        this.run();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this$props = this.props,
          from = _this$props.from,
          to = _this$props.to;

      if (from !== prevProps.from || to !== prevProps.to) {
        this.setUpdateTimeout();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          message = _this$props2.message,
          from = _this$props2.from,
          to = _this$props2.to;
      var duration = (0, _humanTime.humanDiff)(from, to);

      if (!message) {
        return duration;
      }

      return (0, _sprintfJs.sprintf)(message, duration);
    }
  }]);
  return Duration;
}(_react.PureComponent);

exports.default = Duration;
Duration.propTypes = process.env.NODE_ENV !== "production" ? {
  from: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _momentPropType.default]).isRequired,
  to: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _momentPropType.default]),
  message: _propTypes.default.string
} : {};